import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiStepForm } from '../components';
import { useTheme } from '../../../../theme/useTheme';

export const CustomerSignUpPage = () => {
    const navigate = useNavigate();
    const { setOverrideMode } = useTheme();

    useEffect(() => {
        setOverrideMode("light");
        return () => setOverrideMode(null);
    }, [setOverrideMode]);

    const handleBack = () => {
        navigate('/')
    }

    return (<MultiStepForm onBack={handleBack} />)
}